<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15rem"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <main class="flex flex-col items-center justify-center">
      <h3 class="text-2xl text-fg-default">Retry Payout</h3>
      <p
        style="word-break: normal"
        class="leading-loose text-xs text-center lg:w-11-12 my-4 lg:text-sm font-light"
      >
        By clicking on retry, you agree that all the information provided are
        for the completion of this process.
      </p>
      <div class="flex items-center gap-x-3 mt-4 w-full px-4">
        <el-button
          class="border-primary text-primary w-full px-4 py-3.5 shadow-xs rounded-lg"
          @click="handleClose"
          >No, Go Back</el-button
        >
        <el-button
          class="bg-primary text-fg-on-accent px-4 py-3.5 shadow-xs rounded-lg w-full"
          @click="$emit('handleRetryBulkPayout')"
          >Yes, Retry</el-button
        >
      </div>
    </main>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'StartWireTransfer',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '85%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
li {
  word-break: normal;
}
@media screen and (max-width: 768px) {
  >>> .el-radio__label {
    font-size: 12px;
  }
}
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
@media screen and (min-width: 1280px) {
  >>> .el-dialog {
    margin-right: 33vw;
  }
}
@media screen and (min-width: 1680px) {
  >>> .el-dialog {
    margin-right: 34vw;
  }
}
</style>
